import type { UIMessage } from 'ai'
import { getLaunchContextFromMessage, isLaunchSentinel } from './launchContext'
import type { HavenEntryPoint, PageContext } from './types'

interface PrepareChatRequestParams {
  messages: UIMessage[]
  conversationId: number | null
  pageContext: PageContext
  entryPoint?: HavenEntryPoint | null
  extraBody?: object
}

export const prepareChatRequestBody = ({
  messages,
  conversationId,
  pageContext,
  entryPoint,
  extraBody,
}: PrepareChatRequestParams): Record<string, unknown> => {
  const last = messages[messages.length - 1]
  const launchContext = last ? getLaunchContextFromMessage(last) : null
  const body: Record<string, unknown> = {
    ...(conversationId ? { conversationId } : {}),
    ...(launchContext ? { launchContext } : {}),
    ...(entryPoint ? { entryPoint } : {}),
    pageContext,
    ...extraBody,
    operatorHoldCapable: true,
  }
  return {
    ...body,
    messages:
      body.toolOutcome || body.launchContext
        ? []
        : messages.filter((m) => !isLaunchSentinel(m)).slice(-1),
  }
}
